import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';
import { CheckboxChangeEvent } from 'primeng/checkbox';

@Component({
  selector: 'sbi-cot-back-button-table-config',
  templateUrl: './button-table-config.component.html',
  styleUrls: ['./button-table-config.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  },
  standalone: false,
})
export class ButtonTableConfigComponent {
  @Input() set listColumns(val: any[]) {
    this.internalListColumns = val;
    this._fillSelectedList();
  }
  @Input() isLoading = false;
  @Output() saveConfig = new EventEmitter();
  @Output() changeConfig = new EventEmitter();

  internalListColumns = null;
  selectedListColumns = null;
  isOpen: boolean = false;
  checkAll: boolean = false;

  @ViewChild('multiSelectRef') multiSelect: MultiSelect;

  // Constructor
  constructor() {}

  private _fillSelectedList() {
    if (!this.internalListColumns) {
      return;
    }
    this.selectedListColumns = this.internalListColumns.filter(
      column => column.visible
    );

    this.checkAll =
      this.selectedListColumns.length === this.internalListColumns.length;
  }

  onClickAll() {
    this.selectedListColumns = this.internalListColumns;
    this.checkAll = true;
    this.changeConfig.emit(this.selectedListColumns);
  }

  onClose($event) {
    this.isOpen = false;
    this.multiSelect.hide();
    $event.preventDefault();
    $event.stopPropagation();
  }

  onClick(event) {
    let clickedElement = event.target;
    let isInsideModal = false;

    // Traverse up the DOM tree to check if the clicked element
    // or any of its ancestors have the 'p-multiselect-panel' class.
    while (clickedElement) {
      if (
        clickedElement.classList.contains('p-multiselect-overlay') ||
        clickedElement.classList.contains('p-checkbox-icon')
      ) {
        isInsideModal = true;
        break;
      }
      clickedElement = clickedElement.parentElement;
    }

    // If the click was outside the modal and the modal is open, close it.
    if (!isInsideModal && this.isOpen) {
      this.isOpen = false;
      this.multiSelect.hide();
    }
  }

  onConfigurarTabla($event) {
    this.isOpen = !this.isOpen;

    if (!this.isOpen) {
      this.multiSelect.hide();
    } else {
      this.multiSelect.hide();
      this.multiSelect.show();
    }

    $event.stopPropagation();
  }

  onPanelShow() {
    this.isOpen = true;
  }

  onPanelHide() {
    if (this.isOpen) {
      this.multiSelect.show();
    }
  }

  onSaveConfig($event) {
    this.isOpen = false;
    this.multiSelect.hide();
    $event.stopPropagation();

    this.saveConfig.emit(this.internalListColumns);
  }

  onChange($event) {
    if ($event?.value?.length < 3) {
      this.selectedListColumns.push($event.itemValue);
    }
    this.checkAll =
      this.selectedListColumns.length === this.internalListColumns.length;
    this.changeConfig.emit(this.selectedListColumns);
  }
}
